export default "__VITE_ASSET__2tVGM5cR__"